﻿import { of } from 'rxjs';
import { MoveInDate, PlanStatus, ProductType, ResultType, SpecStatus } from 'features/searchResultsFacets';
import { getCommunityMapPoints$, getHomeMapPoints$ } from '../apis/getMarkers';

const hasAvailableNow = (homeStatus) => {
  const statusArray = homeStatus?.split?.(',');

  return statusArray?.some(
    (key) => PlanStatus.fromKey(key) === PlanStatus.AvailableNow || SpecStatus.fromKey(key) === SpecStatus.AvailableNow
  );
};

const getDefaultEndpoints = (parameters) => ({
  communities: getCommunityMapPoints$(parameters),
  homes: getHomeMapPoints$(parameters),
});

/*
*  getEndpointsByFacts
*  validates conditions in the "facts" leaf that will provoke to output an empty array of markers
*  in either communities or homes marker endpoint.
*/
const getEndpointsByFacts = (facts) => {
  // Avoid returning buildable plan when whe have move in date and home status active
  if (
    facts.moveInDateRange === MoveInDate.OneToTwoMonths.toString() ||
    facts.moveInDateRange === MoveInDate.ThreeToSixMonths.toString()
  ) {
    return { communities: of([]) };
  }

  if (hasAvailableNow(facts.homeStatus)) {
    return { communities: of([]) };
  }

  return {};
};

/*
*  getEndpointsByProduct
*  validates conditions in the "product" leaf that will provoke to output an empty array of markers
*  in either communities or homes marker endpoint.
*/
const getEndpointsByProduct = (product) => {
  const endpoints = {};
  if (product.productType !== ProductType.Homes.toString()) {
    endpoints.homes = of([]);
  }

  if (
    product.productType === ProductType.Custom.toString() ||
    product.productType === ProductType.BuildOnYourLot.toString()
  ) {
    endpoints.communities = of([]);
  }

  return endpoints;
};

/*
*  getEndpointsByResult
*  validates conditions in the "results" leaf that will provoke to output an empty array of markers
*  in either communities or homes marker endpoint.
*/
const getEndpointsByResult = (result) => {
  const endpoints = {};
  if (result.resultType === ResultType.Builders.toString()) {
    endpoints.homes = of([]);
    endpoints.communities = of([]);
  }

  return endpoints;
};

export default (parameters) => {
  const defaultEndpoints = getDefaultEndpoints(parameters);
  const endpointsByFacts = getEndpointsByFacts(parameters.facts);
  const endpointsByProduct = getEndpointsByProduct(parameters.product);
  const endpointsByResult = getEndpointsByResult(parameters.results);

  // Hack caused by inconsistent values for MoveInDate for communities
  if (
    parameters.product.productType !== ProductType.Homes.toString() &&
    parameters.product.productType !== ProductType.Custom.toString() &&
    parameters.product.productType !== ProductType.BuildOnYourLot.toString()
  ) {
    endpointsByProduct.communities = defaultEndpoints.communities;
  }

  return Object.assign({}, defaultEndpoints, endpointsByFacts, endpointsByProduct, endpointsByResult);
};
